import {
  ACTIVATE_DEVICE,
  ACTIVATE_DEVICE_ERROR,
  ACTIVATE_DEVICE_SUCCESS,
  FETCH_DEVICE_ACT_INFO,
  FETCH_DEVICE_ACT_INFO_ERROR,
  FETCH_DEVICE_ACT_INFO_SUCCESS,
} from "../../actions/common/configurationAction";

const INIT_STATE = {
  deviceInfo: {
    error: null,
    data: null,
    activating: false,
    fetching: false,
    status: "",
  },
};

const STATUS = {
  SUCCESS: "success",
  ERROR: "error",
  DEFAULT: "",
};

const updateDeviceInfo = (state, changes) => ({
  ...state,
  deviceInfo: { ...state.deviceInfo, ...changes },
});

export const configurationReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case FETCH_DEVICE_ACT_INFO:
      return updateDeviceInfo(state, {
        fetching: true,
        error: null,
        status: STATUS.DEFAULT,
      });
    case FETCH_DEVICE_ACT_INFO_SUCCESS:
      return updateDeviceInfo(state, {
        fetching: false,
        data: action.payload,
        status: STATUS.SUCCESS,
      });
    case FETCH_DEVICE_ACT_INFO_ERROR:
      return updateDeviceInfo(state, {
        fetching: false,
        error: action.error,
        status: STATUS.ERROR,
      });

    case ACTIVATE_DEVICE:
      return updateDeviceInfo(state, {
        activating: true,
        error: null,
        status: STATUS.DEFAULT,
      });
    case ACTIVATE_DEVICE_SUCCESS:
      const existing = state.deviceInfo.data.some(
        device => device.mipId === action.payload.mipId
      );

      if (state.deviceInfo.data === null) {
        return updateDeviceInfo(state, {
          activating: false,
          status: STATUS.SUCCESS,
          data: [action.payload],
        });
      }

      return updateDeviceInfo(state, {
        activating: false,
        status: STATUS.SUCCESS,
        data: existing
          ? state.deviceInfo.data.map((device) =>
              device.mipId === action.payload.mipId ? action.payload : device
            )
          : [...state.deviceInfo.data, action.payload],
      });
    case ACTIVATE_DEVICE_ERROR:
      return updateDeviceInfo(state, {
        activating: false,
        error: action.error,
        status: STATUS.ERROR,
      });

    default:
      return state;
  }
};
